import React from 'react';
import { Link } from 'react-router-dom';

const Support = () => {
  return (
    <div className="page support">
      <h1>Support</h1>
      <p>Need help? We're here for you.</p>
      <p>
        <strong>CarEx Marketplace</strong> is a product of{' '}
        <strong>Inspire The Next Inc.</strong> Use the contacts below for customer
        service on listings, payments, account issues, and disputes.
      </p>

      <div className="contact-info">
        <h2>Contact Us</h2>
        <p>For general inquiries or support requests, please reach out to us:</p>
        <ul>
          <li>
            Email:{' '}
            <a href="mailto:support@carexmarket.com">support@carexmarket.com</a>
          </li>
          <li>
            Phone:{' '}
            <a href="tel:+19173763763">+1 (917) 376-3763</a>
          </li>
        </ul>
        <p className="support-note">
          We aim to respond to email within two business days. For return, refund, and
          cancellation policies, see our{' '}
          <Link to="/marketplace-policies">Marketplace policies</Link>.
        </p>
      </div>

      <div className="faq">
        <h2>Frequently Asked Questions</h2>
        <details>
          <summary>How do I list my car?</summary>
          <p>Download the CarEx app, create an account, and tap the "Sell" button to start your listing.</p>
        </details>
        <details>
          <summary>Is there a fee to buy?</summary>
          <p>Browsing and contacting sellers is free. Premium features may have associated costs.</p>
        </details>
      </div>
    </div>
  );
};

export default Support;

